export const AGRUPACIONES_RANKING = ["Producto", "Cliente", "Operador", "FormaPago", "Dia", "Hora"];

export const ESTADOS_VENTAS = [
  "VentaCreada",
  "StockProcesado",
  "RemitoGenerado",
  "PendienteFacturacion",
  "Facturada",
  "PendienteARCA",
  "Autorizada",
  "ErrorFacturaOARCA",
];

const ETIQUETAS_ESTADO = {
  ErrorFacturaOARCA: "Error factura ARCA",
};

export const textoEstadoVenta = (estado = "") => ETIQUETAS_ESTADO[estado]
  || estado.replace(/([a-záéíóú])([A-ZÁÉÍÓÚ])/g, "$1 $2");

export const crearOpcionesFiltrosVentas = ({
  clientes = [],
  productos = [],
  operadores = [],
  formasPago = [],
} = {}) => ({
  clientes: clientes.map((item) => ({
    ...item,
    Id: Number(item?.Id) || 0,
    sCodigo: String(item?.sCodigo ?? "").trim(),
    sDescripcion: String(item?.sDescripcion ?? "").trim(),
  })).filter((item) => item.Id > 0 && item.sDescripcion),
  productos: productos.map((item) => ({
    ...item,
    Id: Number(item?.Id) || 0,
    sCodigo: String(item?.sCodigo ?? "").trim(),
    sDescripcion: String(item?.sDescripcion ?? "").trim(),
  })).filter((item) => item.Id > 0 && item.sDescripcion),
  operadores: operadores.map((item) => {
    const nombre = [item?.Nombre, item?.Apellido].filter(Boolean).join(" ").trim();
    const mail = String(item?.Mail ?? "").trim();
    return {
      ...item,
      Id: Number(item?.OperadorId ?? item?.Id) || 0,
      sCodigo: mail,
      sDescripcion: nombre || mail,
    };
  }).filter((item) => item.Id > 0 && item.sDescripcion),
  estados: ESTADOS_VENTAS.map((estado) => ({
    Id: estado,
    sCodigo: estado,
    sDescripcion: textoEstadoVenta(estado),
  })),
  formasPago: formasPago.map((item) => ({
    ...item,
    Id: Number(item?.Id ?? item?.FormaPagoId) || 0,
    sCodigo: String(item?.sCodigo ?? item?.Codigo ?? "").trim(),
    sDescripcion: String(item?.sDescripcion ?? item?.Descripcion ?? item?.FormaPago ?? "").trim(),
  })).filter((item) => item.sDescripcion),
});

const normalizarBusquedaFiltro = (valor) => String(valor ?? "")
  .normalize("NFD")
  .replace(/\p{Diacritic}/gu, "")
  .toLocaleLowerCase("es")
  .trim();

export const filtrarOpcionesVentas = (lista = [], consulta = "") => {
  const texto = normalizarBusquedaFiltro(consulta);
  if (!texto) return [...lista];
  return lista.filter((item) => [item?.sDescripcion, item?.sCodigo]
    .some((valor) => normalizarBusquedaFiltro(valor).includes(texto)));
};

const fechaValida = (valor) => /^\d{4}-\d{2}-\d{2}$/.test(String(valor || ""));
const diasInclusivos = (desde, hasta) => {
  const inicio = new Date(`${desde}T00:00:00Z`);
  const fin = new Date(`${hasta}T00:00:00Z`);
  return Math.floor((fin - inicio) / 86400000) + 1;
};

export const validarVentasFiltros = (filtros = {}) => {
  const errores = [];
  if (!fechaValida(filtros.FechaDesde) || !fechaValida(filtros.FechaHasta)) {
    errores.push("Debe indicar fechas validas.");
  } else {
    const dias = diasInclusivos(filtros.FechaDesde, filtros.FechaHasta);
    if (dias <= 0) errores.push("FechaHasta no puede ser anterior a FechaDesde.");
    if (dias > 366) errores.push("El rango no puede superar 366 dias.");
  }
  if (!Number.isInteger(Number(filtros.Pagina)) || Number(filtros.Pagina) < 1) errores.push("Pagina debe comenzar en 1.");
  if (!Number.isInteger(Number(filtros.TamanoPagina)) || Number(filtros.TamanoPagina) < 1 || Number(filtros.TamanoPagina) > 200) {
    errores.push("TamanoPagina debe estar entre 1 y 200.");
  }
  return { valido: errores.length === 0, errores };
};

export const crearVentasFiltros = ({ EmpresaId, ...filtros }) => {
  const request = {
    EmpresaId,
    FechaDesde: filtros.FechaDesde,
    FechaHasta: filtros.FechaHasta,
    Pagina: Number(filtros.Pagina),
    TamanoPagina: Number(filtros.TamanoPagina),
  };
  for (const campo of ["ClienteId", "MercaderiaId", "OperadorId"]) {
    const valor = Number(filtros[campo]);
    if (Number.isFinite(valor) && valor > 0) request[campo] = valor;
  }
  for (const campo of ["Estado", "FormaPago"]) {
    const valor = filtros[campo];
    if (valor !== undefined && valor !== null && valor !== "") request[campo] = valor;
  }
  return request;
};

export const normalizarRankingVentas = (lista = [], limite = 7) => [...lista]
  .sort((a, b) => Number(a.Posicion) - Number(b.Posicion) || Number(b.VentaNeta) - Number(a.VentaNeta))
  .slice(0, limite)
  .map((item) => ({
    clave: item.Clave,
    nombre: item.Descripcion || item.Clave || "Sin identificar",
    venta: Number(item.VentaNeta) || 0,
  }));

export const normalizarEstadosVentas = (estados = []) => ESTADOS_VENTAS.map((Estado) => ({
  Estado,
  Cantidad: Number(estados.find((item) => item.Estado === Estado)?.Cantidad) || 0,
}));

export const calcularPaginasVentas = (totalRegistros, tamanoPagina) => Math.max(
  1,
  Math.ceil((Number(totalRegistros) || 0) / Math.max(1, Number(tamanoPagina) || 1)),
);
